import React from 'react';
import { ErrorBoundary as ReactErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { noteBoundaryCaughtError } from 'helpers/boundaryCaughtErrors';
import { reportReactError } from 'helpers/reactErrorReporting';

interface ErrorBoundaryWrapperProps {
  fallback: React.ReactNode;
  children: React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
  onReset?: () => void;
}

const ErrorBoundaryWrapper: React.FC<ErrorBoundaryWrapperProps> = ({
  fallback,
  onError,
  ...props
}) => {
  // Use type assertion to bypass the ReactNode compatibility issue
  const ErrorBoundaryComponent = ReactErrorBoundary as any;

  const renderFallback = ({ error }: FallbackProps) => {
    noteBoundaryCaughtError(error);
    return fallback;
  };

  const reportError = (error: Error, errorInfo: React.ErrorInfo) => {
    reportReactError(error, errorInfo);
    onError?.(error, errorInfo);
  };

  return (
    <ErrorBoundaryComponent {...props} fallbackRender={renderFallback} onError={reportError} />
  );
};

export default ErrorBoundaryWrapper;
